var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "task-page" }, [
    _c("header", { staticClass: "tk-hero" }, [
      _c("div", { staticClass: "hero-top" }, [
        _c("span", { staticClass: "hero-back", on: { click: _vm.goBack } }, [
          _vm._v("‹"),
        ]),
        _c("span", { staticClass: "hero-title" }, [_vm._v("作业详情")]),
        _c("span", { staticClass: "hero-back ghost" }),
      ]),
      _vm.detail
        ? _c("div", { staticClass: "tk-title-row" }, [
            _c(
              "span",
              {
                staticClass: "tk-badge",
                style: {
                  background: _vm.detail.meta.bg,
                  color: _vm.detail.meta.fg,
                },
              },
              [_vm._v(" " + _vm._s(_vm.detail.meta.short) + " ")]
            ),
            _c("div", { staticClass: "tk-name" }, [
              _c("p", { staticClass: "tk-h1" }, [
                _vm._v(_vm._s(_vm.detail.title)),
              ]),
              _c("p", { staticClass: "tk-sub" }, [
                _vm._v(_vm._s(_vm.subjectText)),
              ]),
            ]),
            _c(
              "span",
              {
                staticClass: "tk-status",
                style: {
                  background: _vm.detail.statusMeta.bg,
                  color: _vm.detail.statusMeta.fg,
                },
              },
              [_vm._v(" " + _vm._s(_vm.detail.statusMeta.text) + " ")]
            ),
          ])
        : _vm._e(),
    ]),
    _vm.detail
      ? _c("main", { staticClass: "tk-body" }, [
          _c(
            "section",
            { staticClass: "due-card", class: "lv-" + _vm.detail.level },
            [
              _c("div", { staticClass: "due-main" }, [
                _c("p", { staticClass: "due-label" }, [_vm._v("截止时间")]),
                _c("p", { staticClass: "due-time" }, [
                  _vm._v(_vm._s(_vm.detail.dueAt)),
                ]),
              ]),
              _c("div", { staticClass: "due-side" }, [
                _c("span", { staticClass: "due-left" }, [
                  _vm._v(_vm._s(_vm.detail.leftText)),
                ]),
              ]),
              _vm.detail.remind
                ? _c("p", { staticClass: "due-remind" }, [
                    _vm._v(_vm._s(_vm.detail.remind)),
                  ])
                : _vm._e(),
            ]
          ),
          _c("section", { staticClass: "block" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "card" },
              _vm._l(_vm.detail.require, function (r, i) {
                return _c("p", { key: i, staticClass: "req" }, [
                  _c("em", [_vm._v(_vm._s(i + 1))]),
                  _c("span", [_vm._v(_vm._s(r))]),
                ])
              }),
              0
            ),
          ]),
          _vm.detail.attach && _vm.detail.attach.length
            ? _c("section", { staticClass: "block" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "card" },
                  _vm._l(_vm.detail.attach, function (f) {
                    return _c(
                      "p",
                      {
                        key: f.name,
                        staticClass: "file",
                        on: {
                          click: function ($event) {
                            return _vm.download(f)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "f-ico" }, [_vm._v("附")]),
                        _c("span", { staticClass: "f-name" }, [
                          _vm._v(_vm._s(f.name)),
                        ]),
                        _c("span", { staticClass: "f-size" }, [
                          _vm._v(_vm._s(f.size)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _c("section", { staticClass: "block" }, [
            _vm._m(2),
            _c(
              "div",
              { staticClass: "card" },
              [
                _vm.detail.submit
                  ? [
                      _c("p", { staticClass: "sub-time" }, [
                        _vm._v("提交于 " + _vm._s(_vm.detail.submit.time)),
                      ]),
                      _vm._l(_vm.detail.submit.files, function (f) {
                        return _c("p", { key: f.name, staticClass: "file" }, [
                          _c("i", { staticClass: "f-ico ok" }, [_vm._v("件")]),
                          _c("span", { staticClass: "f-name" }, [
                            _vm._v(_vm._s(f.name)),
                          ]),
                          _c("span", { staticClass: "f-size" }, [
                            _vm._v(_vm._s(f.size)),
                          ]),
                        ])
                      }),
                    ]
                  : _c("p", { staticClass: "empty" }, [
                      _vm._v("还没有提交，截止前记得交一下"),
                    ]),
              ],
              2
            ),
          ]),
          _vm.detail.submit &&
          (_vm.detail.submit.score !== null || _vm.detail.submit.comment)
            ? _c("section", { staticClass: "block tk-correct" }, [
                _vm._m(3),
                _c("div", { staticClass: "card" }, [
                  _vm.detail.submit.score !== null
                    ? _c("div", { staticClass: "score-row" }, [
                        _c("em", [_vm._v(_vm._s(_vm.detail.submit.score))]),
                        _vm.detail.submit.full
                          ? _c("span", { staticClass: "score-full" }, [
                              _vm._v("/ " + _vm._s(_vm.detail.submit.full)),
                            ])
                          : _vm._e(),
                        _c("span", { staticClass: "score-teacher" }, [
                          _vm._v(_vm._s(_vm.detail.submit.teacher)),
                        ]),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "comment" }, [
                    _vm._v(_vm._s(_vm.detail.submit.comment)),
                  ]),
                  _vm.detail.submit.fixes && _vm.detail.submit.fixes.length
                    ? _c(
                        "div",
                        { staticClass: "fixes" },
                        [
                          _c("p", { staticClass: "fixes-title" }, [
                            _vm._v("要订正的地方"),
                          ]),
                          _vm._l(_vm.detail.submit.fixes, function (f, i) {
                            return _c("p", { key: i, staticClass: "fix" }, [
                              _vm._v(_vm._s(f)),
                            ])
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _c("p", { staticClass: "tip" }, [
            _vm._v("演示数据 · 接入作业表后按同样的结构返回即可"),
          ]),
        ])
      : _c("main", { staticClass: "tk-body" }, [
          _c("p", { staticClass: "empty-lg" }, [
            _vm._v("没找到这份作业，可能已经下架了"),
          ]),
        ]),
    _vm.detail
      ? _c("div", { staticClass: "tk-bar" }, [
          _c("span", { staticClass: "bar-tip" }, [_vm._v(_vm._s(_vm.barTip))]),
          _c(
            "span",
            { staticClass: "bar-btn", on: { click: _vm.handleAction } },
            [_vm._v(_vm._s(_vm.barText))]
          ),
        ])
      : _vm._e(),
    _vm.toast
      ? _c("p", { staticClass: "toast-tip" }, [_vm._v(_vm._s(_vm.toast))])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "block-head" }, [
      _c("span", { staticClass: "block-title" }, [_vm._v("作业要求")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "block-head" }, [
      _c("span", { staticClass: "block-title" }, [_vm._v("老师发的附件")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "block-head" }, [
      _c("span", { staticClass: "block-title" }, [_vm._v("我的提交")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "block-head" }, [
      _c("span", { staticClass: "block-title" }, [_vm._v("老师批改")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }